import React, { useEffect, useRef, useState } from 'react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ROLE_HOME = { admin: '/panel', doctora: '/clinica/panel', enfermera: '/clinica/panel', administradora: '/clinica/panel', community: '/clinica/panel' };

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      window.location.replace('/login');
      return;
    }
    (async () => {
      try {
        const res = await fetch(`${API}/auth/google/session`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: match[1] }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'No se pudo iniciar sesión con Google');
        window.localStorage.setItem('n369_has_session', '1');
        window.localStorage.setItem('n369_auth_issued_at', Date.now().toString());
        window.localStorage.setItem('n369_auth_last_activity', Date.now().toString());
        if (data.user?.email) window.localStorage.setItem('n369_last_login_email', data.user.email);
        window.history.replaceState(null, '', window.location.pathname);
        window.location.replace(ROLE_HOME[data.user?.role] || '/panel');
      } catch (err) {
        setError(err.message);
      }
    })();
  }, []);

  return (
    <main className="min-h-screen flex items-center justify-center bg-[#02040a] text-white" data-testid="auth-callback-page">
      {error ? (
        <div className="text-center">
          <p className="text-red-400 text-sm mb-4" data-testid="auth-callback-error">{error}</p>
          <a href="/login" className="rounded-full bg-[#00d4ff] px-6 py-3 text-sm font-bold text-slate-950">Volver al acceso</a>
        </div>
      ) : (
        <p className="text-sm text-slate-300 animate-pulse" data-testid="auth-callback-loading">Conectando con Google…</p>
      )}
    </main>
  );
}
